// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"ActualOwnerOfResources_modal-content_2duS4"};